import React from 'react';
import { compact } from 'lodash';
import { Component as ComponentContainer } from '@styles/layout';
import { ExpandableListItem } from '@components/material-ui';
import { ExpandableListComponent } from '@model/content';
import { ExpandableListGroupItem } from '@model/common';
import { SectionTitle } from '@components/common/section-title';

export const ExpandableListContainer = ({ title, items }: ExpandableListComponent) => {
  const formattedItems: Array<ExpandableListGroupItem> = items.map(({ title, description }) => ({
    title,
    text: description
  }));

  return (
    <ComponentContainer>
      <SectionTitle heading={title} />
      <div>
        <ExpandableListItem items={compact(formattedItems)} />
      </div>
    </ComponentContainer>
  );
};
